import {lazy} from 'react'

const GiftShopFeedScreen = lazy(
  () => import(/* webpackChunkName: 'Feed' */ './GiftShopFeedScreen'),
)

export {GiftShopFeedScreen}
